import React from 'react';
import HistoryTableHeader from './historyTableHeader';
import { TemporaryLicenseColumnCaptions } from './tableColumnCaptions';

const TemporaryLicenseHistoryTableHeader = (props) => {
  const { editedFields, objectData } = props;

  const title = [{
    title: TemporaryLicenseColumnCaptions.key,
    value: objectData ? objectData.key : '',
  }, {
    title: TemporaryLicenseColumnCaptions.client.fullName,
    value: objectData
      ? objectData.client
        ? objectData.client.fullName : ''
      : ''
  }, {
    title: TemporaryLicenseColumnCaptions.obtainingMethod,
    value: objectData
      ? objectData.obtainingMethod
        ? objectData.obtainingMethod : ''
      : ''
  }];

  return <HistoryTableHeader editedFields={editedFields} captions={TemporaryLicenseColumnCaptions} objectData={objectData} title={title}/>
};

export default TemporaryLicenseHistoryTableHeader;


// WEBPACK FOOTER //
// ./src/components/temporaryLicenseHistoryTableHeader.js